'use strict';

var _ = require('underscore');

function bindActionCreator(actionCreator, dispatch) {
  return function boundActionCreator() {
    return dispatch(actionCreator.apply(null, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
module.exports = function bindActionCreators(actionCreators, dispatch) {
  if (_.isFunction(actionCreators)) {
    return bindActionCreator(actionCreators, dispatch);
  }

  var actionCreatorMessage = actionCreators === null ? 'null' : typeof actionCreators;

  if (typeof actionCreators !== 'object' || actionCreators === null || actionCreators === undefined) { 
    throw new Error('bindActionCreators expected an object or a function, instead received ' + actionCreatorMessage + '. ');
  }

  return _.mapObject(actionCreators, function mapBindActionCreator(actionCreator) {
    return bindActionCreator(actionCreator, dispatch);
  });
};
